module.exports = __webpack_public_path__ + "img/icon-questions__circle.3899779f.svg";